<template>
  <oie-header-switch
    v-if="!hideSwitch"
    :is-for="isFor"
    :value="useVat"
    :label-text="tStatic('showPricesWithVat')"
    @toggle="toggleCheckbox($event)">
  </oie-header-switch>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    forceOff: {
      type: Boolean,
      default: false
    },
    isFor: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('ui', ['useVat']),
    hideSwitch() {
      return this.forceOff
    }
  },
  mounted() {
    if (this.forceOff && this.useVat) {
      this.toggleCheckbox(false)
    }
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    toggleCheckbox(value) {
      this.toggleValue({ key: 'useVat', data: value })
      this.$store.dispatch('commerce/getCart', 0)
    }
  }
}
</script>
